import { getProductsInventory } from '@api/apiCalls'
import { updateVariants } from '@helpers/filters'
import trackError from '@helpers/trackError'
import { useEffect, useState } from 'react'
import { Collection } from 'types/collection'

function getCollectionsWithFilteredVariants(
  collections: Collection[] = [],
  variants = {}
) {
  return collections.map(collection => {
    const items = updateVariants(collection.items, variants)
    return {
      ...collection,
      items
    }
  })
}

export function useFetchVariants(
  productIds: number[],
  productTypes: string[],
  collections: Collection[]
) {
  const [updatedCollections, setUpdatedCollection] = useState(collections)
  const [variantExist, setVariantExist] = useState(false)

  useEffect(() => {
    const fetchVariants = async () => {
      try {
        const variants = await getProductsInventory(productIds, productTypes)
        const filteredCollection = getCollectionsWithFilteredVariants(
          collections,
          variants
        )
        setUpdatedCollection(filteredCollection)
        setVariantExist(true)
      } catch (e) {
        const variantsError = new Error(
          'Collection Product fetchVariants failed'
        )
        const error = e instanceof Error ? e : variantsError
        trackError(variantsError, { error })
      }
    }

    if (productIds?.length) fetchVariants()
  }, [productIds, productTypes, collections])

  return { updatedCollections, variantExist }
}
